
















import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'node_modules/vue-router/types';

@Component
export default class Issues extends Vue {
  private async beforeRouteEnter(to: Route, from: Route, next: (vm?: any) => void) {
    next((vm: Issues) => {
      vm.$socket.emit('joinRoom', `my-issues-${vm.$store.state.currentUser._id}`);
    });
  }

  private beforeRouteLeave(to: Route, from: Route, next: (vm?: any) => void) {
    this.$socket.emit('leaveRoom', `my-issues-${this.$store.state.currentUser._id}`);
    next();
  }
}
